import {intlShape, utils} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {Form} from 'react-bootstrap';
import {defineMessages, injectIntl} from 'react-intl';

import {FilterSubmitButton} from './FilterSubmitButton';
import styles from './UserFilterSaveButton.less';

const I18N = defineMessages({
  INPUT: {
    id: 'filter.user.save.input',
    defaultMessage: 'Type filter name ...',
    description: 'text for user filter name input',
  },
  TEXT: {
    id: 'filter.user.save.text',
    defaultMessage: 'SAVE USER FILTER',
    description: 'text for save filter button',
  },
  TITLE: {
    id: 'filter.user.save.title',
    defaultMessage: 'Save user filter',
    description: 'title text for save filter button',
  },
  EMPTY_ERROR: {
    id: 'filter.user.save.emptyError',
    defaultMessage: 'Filter name cannot be empty',
    description: 'error text for save filter button',
  },
});

class UserFilterSaveButton extends React.PureComponent {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      text: '',
      error: false,
    };
  }

  handleChange(event) {
    if (event) {
      event.stopPropagation();
    }
    this.setState({text: event.target.value});
  }

  handleButtonClick(event) {
    const {onClick} = this.props;
    const {text} = this.state;
    if (event) {
      event.stopPropagation();
    }
    if (isEmpty(text)) {
      this.setState({error: true});
    } else {
      this.setState({error: false});
      onClick(text);
    }
  }

  render() {
    const {intl, isDisabled, titleText} = this.props;
    const {error, text} = this.state;
    return (
      <div>
        {error ? (
          <div className={styles.dlErrorMessage}>
            {utils.TranslateUtils.translate(I18N.EMPTY_ERROR, intl)}
          </div>
        ) : null}
        <span className={styles.dlUserFilterSaveButton}>
          <Form.Control
            as='input'
            type='text'
            size='sm'
            className={styles.dlUserFilterSaveButtonInput}
            value={text}
            placeholder={utils.TranslateUtils.translate(I18N.INPUT, intl)}
            onChange={this.handleChange}
          />
          <FilterSubmitButton
            className={styles.dlUserFilterSaveButtonButton}
            buttonText={I18N.TEXT.id}
            titleText={titleText}
            onClick={this.handleButtonClick}
            isDisabled={isDisabled}
          />
        </span>
      </div>
    );
  }
}

UserFilterSaveButton.displayName = 'UserFilterSaveButton';

UserFilterSaveButton.propTypes = {
  intl: intlShape.isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  titleText: PropTypes.string,
};

UserFilterSaveButton.defaultProps = {
  isDisabled: false,
  titleText: 'filter.user.save.title',
};

export default injectIntl(UserFilterSaveButton);
